module.exports = __webpack_public_path__ + "static/media/h14_caregiver.9821941e.webp";